
import 'pages/news/news-list.tag'
import 'pages/news/news-edit.tag'
import 'pages/news/news-categories-list.tag'
riot.tag2('news', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}"><a href="#news/{link}"><span>{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <news-list if="{tab == &quot;news&quot; &amp;&amp; !edit}"></news-list>\n    <news-edit if="{tab == &quot;news&quot; &amp;&amp; edit}"></news-edit>\n    <news-categories-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></news-categories-list>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.tab = '';

self.tabs = [{ title: 'Список новостей', name: 'news', link: '' }, { title: 'Категории', name: 'categories', link: 'categories' }];

route('/news/([0-9]+)', function (id) {
    self.tab = 'news';
    observable.trigger('news-edit', id);
    self.edit = true;
    self.update();
});

route('/news/new..', function () {
    var q = riot.route.query();
    var category = q.category;
    var name = q.name;
    self.tab = 'news';
    self.edit = true;
    observable.trigger('news-new', { category: category, name: name });
    self.update();
});

route('/news/*/([0-9]+)', function (tab, id) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: true, tab: tab });
        observable.trigger(tab + '-edit', id);
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/news', function () {
    self.edit = false;
    self.tab = 'news';
    self.update();
});

route('/news/*', function (tab) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: false, tab: tab });
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/news..', function () {
    self.update({ edit: true, tab: 'not-found' });
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/news/news.tag